var store = {
  debug: true,
  state: {
    scrollTop: 0
  },
  setScrollAction (newValue) {
    if (this.debug) console.log('setScrollAction triggered with', newValue)
    this.state.scrollTop = newValue
  },
  clearScrollAction () {
    if (this.debug) console.log('clearScrollAction triggered')
    this.state.scrollTop = 0
  }
}

export default store


// WEBPACK FOOTER //
// ./src/store.js